import React from 'react';
import { Row, Col } from 'antd';
import Chart from 'chart.js';
import { Line, Bar } from 'react-chartjs-2';
import { chartOptions, parseOptions } from 'variables/charts';

import Card from 'components/Containers/Card';
import Header from 'modules/Student/components/Dashboards/Header';
import JoinedClasses from 'modules/Student/widgets/JoinedClasses';
import MonthlyReviews from 'modules/Student/widgets/MonthlyReviews';
import SimpleContainer from 'components/Containers/SimpleContainer';

import colors from 'constants/colors';

// Example 1 of Chart inside src/views/dashboards/Dashboard.js
const Chart_HoatDong = {
  options: {
    scales: {
      yAxes: [
        {
          gridLines: {
            color: colors.gray[700],
            zeroLineColor: colors.gray[700],
          },
          ticks: {
            callback: (value) => {
              if (!(value % 10)) {
                return `${value} bài tập`;
              }
              return value;
            },
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: (item, data) => {
          const label = data.datasets[item.datasetIndex].label || '';
          const { yLabel } = item;
          let content = '';

          if (data.datasets.length > 1) {
            content += label;
          }

          content += `Hoàn thành ${yLabel} bài tập`;
          return content;
        },
      },
    },
  },
  data: (canvas) => {
    return {
      labels: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6'],
      datasets: [
        {
          label: 'Performance',
          data: [0, 0, 0, 0, 0, 0, 0],
        },
      ],
    };
  },
};

const Chart_DanhGiaThuongXuyen = {
  options: {
    title: {
      display: false,
      text: 'Chart',
    },
    scales: {
      yAxes: [
        {
          gridLines: {
            color: colors.gray[200],
            zeroLineColor: colors.gray[200],
          },
          ticks: {
            callback: (value) => {
              if (!(value % 10)) {
                return value;
              }
              return value;
            },
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: (item, data) => {
          const label = data.datasets[item.datasetIndex].label || '';
          const { yLabel } = item;
          let content = '';
          if (data.datasets.length > 1) {
            content += label;
          }
          content += yLabel;
          return content;
        },
      },
    },
  },
  data: {
    labels: ['T.1', 'T.2', 'T.3', 'T.4', 'T.5', 'T.6'],
    datasets: [
      {
        label: 'Sales',
        data: [0, 0, 0, 0, 0, 0],
        maxBarThickness: 10,
      },
    ],
  },
};

export default function Home() {
  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }

  return (
    <div>
      <Header name='Trang chủ' parentName='LMS' />
      <SimpleContainer>
        <Row gutter={24}>
          <Col span={24} xl={18} lg={16} md={14} sm={12}>
            <Card title='Số lượng bài tập đã hoàn thành' subTitle='Bài tập' style={{ minHeight: 300 }} className='bg-default' headerClassName='bg-transparent' titleClassName='text-light'>
              <div className='chart'>
                <Line data={Chart_HoatDong.data} options={Chart_HoatDong.options} id='chart-sales-dark' className='chart-canvas' />
              </div>
            </Card>
            <Card title='Các lớp học đã tham gia' style={{ minHeight: 350 }}>
              <JoinedClasses />
            </Card>
          </Col>
          <Col span={24} xl={6} lg={8} md={10} sm={12}>
            <Card title='Đánh giá thường xuyên' subTitle='Năng lực'>
              <div className='chart'>
                <Bar data={Chart_DanhGiaThuongXuyen.data} options={Chart_DanhGiaThuongXuyen.options} className='chart-canvas' id='chart-bars' />
              </div>
            </Card>
            <Card title='Đánh giá thường xuyên' subTitle='Kỹ năng' style={{ minHeight: 350 }}>
              <MonthlyReviews />
            </Card>
          </Col>
        </Row>
      </SimpleContainer>
    </div>
  );
}
